import CookieConsentBanner from '../components/CookieConsentBanner';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100">
      <nav className="border-b border-zinc-800/50">
        <div className="mx-auto max-w-3xl flex items-center justify-between px-6 py-4">
          <a href="/" className="text-sm font-semibold hover:text-white transition-colors">&larr; Back</a>
        </div>
      </nav>
      <main className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-3xl font-bold text-white mb-2">Cookie Policy</h1>
        <p className="text-sm text-zinc-500 mb-10">Effective date: March 8, 2026</p>

        <div className="space-y-10 text-sm text-zinc-300 leading-relaxed">
          <section>
            <p>
              <strong className="text-zinc-200">The One Family, LLC</strong> (d/b/a "MSP Collective") uses cookies and similar technologies on mspcollective.io and app.mspcollective.io. This policy explains what cookies we use, why we use them, and how you can control them.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">1. What Are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences and improve your experience.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">2. Cookies We Use</h2>

            <h3 className="text-sm font-semibold text-zinc-200 mb-3 mt-4">Essential Cookies</h3>
            <p className="mb-3">These cookies are necessary for the site to function and cannot be disabled.</p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-zinc-800 text-left">
                    <th className="py-2 pr-4 text-zinc-300 font-medium">Cookie</th>
                    <th className="py-2 pr-4 text-zinc-300 font-medium">Purpose</th>
                    <th className="py-2 text-zinc-300 font-medium">Duration</th>
                  </tr>
                </thead>
                <tbody className="text-zinc-400">
                  <tr className="border-b border-zinc-800/50">
                    <td className="py-2 pr-4 font-mono text-xs">cookie_consent</td>
                    <td className="py-2 pr-4">Stores your cookie preferences</td>
                    <td className="py-2">1 year (localStorage)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-sm font-semibold text-zinc-200 mb-3 mt-6">Analytics Cookies (Opt-In)</h3>
            <p className="mb-3 text-zinc-500 italic">No analytics cookies are currently in use. This section will be updated if analytics are added.</p>

            <h3 className="text-sm font-semibold text-zinc-200 mb-3 mt-6">Marketing Cookies (Opt-In)</h3>
            <p className="mb-3 text-zinc-500 italic">No marketing cookies are currently in use. This section will be updated if marketing pixels are added.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">3. How to Control Cookies</h2>
            <p>
              When you first visit our site, a cookie consent banner allows you to accept all cookies, reject non-essential cookies, or manage your preferences. You can change your preferences at any time by clearing your browser's local storage and revisiting the site.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">4. Third Parties</h2>
            <p>We do not currently use any third-party cookies on our marketing sites.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">5. Updates</h2>
            <p>We may update this Cookie Policy from time to time. When we make changes that require renewed consent, the cookie banner will reappear.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">6. Contact Us</h2>
            <p>
              Questions? Contact us at{' '}
              <a href="mailto:privacy@theonestack.com" className="text-zinc-200 underline underline-offset-2 hover:text-white">privacy@theonestack.com</a>.
            </p>
          </section>
        </div>
      </main>
      <CookieConsentBanner />
    </div>
  );
}
